import { IPageData, IPageProps } from "../../../interfaces/page-data";
import { useEffect, useRef, useState } from "react";
import { IPrint } from '../../../interfaces/IPrintData';
import { Button, Image, Modal, Pagination, Popconfirm, Space, Tooltip } from "antd";
import { DeleteOutlined, EyeOutlined, PrinterOutlined } from "@ant-design/icons";
import HTTPService from "../../../utils/makerequest";
import { Toast } from "primereact/toast";
import { StateLoader } from "../../../redux/StateLoader";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { useTranslation } from 'react-i18next';
import moment from "moment";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";

const PrintsJobsAPI: React.FunctionComponent<IPageProps> = props => {
    const { onSetPage } = props;
    const { t } = useTranslation();
    const [printList, setPrintList] = useState<IPrint>({});
    const [isModalImage, setIsModalImage] = useState(false);
    const [imageSrc, setImageSrc] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [reprintLoading, setReprintLoading] = useState<{ [key: number]: boolean }>({});
    const loader = new StateLoader();
    const user: IAuthentication = loader.loadAuthState();
    const imagesPerPage = 1
    const [currentPage, setCurrentPage] = useState(1);
    const [modalData, setModalData] = useState('');
    const dataGridRef = useRef<any>(null);
    const toast = useRef<any>(null);

    const pageData: IPageData = {
        title: t('PrintsJobs'),
        loaded: true
    };

    const paginatedImages = () => {
        const startIndex = (currentPage - 1) * imagesPerPage;
        const endIndex = startIndex + imagesPerPage;
        return imageSrc?.labels?.slice(startIndex, endIndex) || [];
    };

    const totalPages = Math.ceil((imageSrc?.labels?.length || 0) / imagesPerPage);


    useEffect(() => {
        onSetPage(pageData);
        dataGridRef.current.GetAllData();
    }, []);

    const TagFilter = (e?) => {
        const filters = e?.filters;

        if (filters?.printederrorDate && Array.isArray(filters.printederrorDate)) {
            const [startDate, endDate] = filters.printederrorDate;
            filters.printDate_Start = startDate;
            filters.printDate_Finish = endDate;
            delete filters.printederrorDate;
        }


        var body = {
            sortColumn: e?.sortField,
            sortOrder: e?.sortOrder || 'asc',
            pageSize: e?.pageSize,
            page: e?.page,
            isExcel: false,
            ...filters
        };

        HTTPService.POST(`/PrintJob/filters`, body).then((response) => {
            if (!response.data) {
                return;
            }
            if (response.status === 200) {
                setPrintList(response.data)
            } else if (response.status === 450) {
                toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t(response.data), life: 3000 });
            }
            else {
                toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t(response.data), life: 3000 });
            }
        });
    };


    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const tagDataColumns: IMUIDataGridColumns[] = [
        ...(user.role !== UserRole.Admin ? [{
            title: t('Company Name'),
            key: 'companyName',
            isSorting: true,
            placeHolder: t('Company Name'),
        }] : []),
        {
            title: t('template_name'),
            key: 'templateName',
            isSorting: true,
            placeHolder: t('template_name'),
            align: 'center',
            headerAlign: 'center',
        },
        {
            title: 'Barcode',
            key: 'barcode',
            placeHolder: 'Barcode',
            align: 'center',
            hideColumnMenu: true,
            headerAlign: 'center',
            render: (order, record) => {
                const barcodes = record.barcode ? record.barcode.split(',') : [];
                if (barcodes.length > 1) {
                    return (
                        <div style={{ maxWidth: '100%', marginLeft: '9px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {barcodes[0]}...
                        </div>
                    );
                }
                return barcodes;
            },
        },
        {
            title: t('printed_error_date'),
            key: 'printederrorDate',
            align: 'center',
            headerAlign: 'center',
            dataType: 'date',
            placeHolder: t('printed_error_date'),
            render: (text) => moment(text).format('DD-MM-YYYY HH:mm'),
        },
        {
            title: t('Printer Name'),
            key: 'printerName',
            align: 'center',
            headerAlign: 'center',
            placeHolder: t('Printer Name'),
            render: (order, record) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 10 }}>

                    <Button size='small' icon={<EyeOutlined />} style={{ display: user.role === UserRole.Sayman ? 'none' : 'block' }} onClick={() => {
                        setModalData(record.printJobDetails);
                        setIsModalVisible(true);
                    }}
                    >
                        {record.printerName}
                    </Button>
                </div>
            ),
        },
        {
            title: t('operations'),
            key: 'operations',
            align: 'center',
            hideColumnMenu: true,
            headerAlign: 'center',
            placeHolder: t('operations'),
            render: (order, record) => (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                    <Space size={4}>
                        <Popconfirm
                            title={t('are_you_sure_printJob')}
                            onConfirm={() => DeletePrintsJobs(record.printJobId)}
                            okText={t('yes')}
                            cancelText={t('no')}
                        >
                            <Tooltip title={t('delete')}>
                                <Button size='small' icon={<DeleteOutlined />} style={{ width: '60px', borderRadius: '70px' }} onClick={(e) => e.stopPropagation()}>
                                </Button>
                            </Tooltip>

                        </Popconfirm>

                        <Tooltip title={t('preview')}>

                            <Button
                                size='small'
                                icon={<EyeOutlined />}
                                style={{ width: '80px', borderRadius: '70px' }}
                                onClick={() => {
                                    ImagePriview(record.printJobId);
                                }}>
                            </Button>

                        </Tooltip>

                        {!record.jobStatus && (
                            <Tooltip title={t('Reprint')}>
                                <Button
                                    size='small'
                                    style={{ width: '60px', borderRadius: '70px' }}
                                    icon={<PrinterOutlined />}
                                    loading={!!reprintLoading[record.printJobId]}
                                    onClick={() => {
                                        PrintData(record.printJobId)
                                    }}>
                                </Button>
                            </Tooltip>

                        )}
                    </Space>

                </div>
            ),
        },
    ];

    const DeletePrintsJobs = (id) => {
        HTTPService.DELETE(`/PrintJob/deletePrintJob?Id=${id}`).then((response) => {
            if (response.status === 200) {
                toast.current?.show({ severity: 'success', summary: t('successful'), detail: t(response.data), life: 3000 });
                dataGridRef.current.GetAllData();
            } else {
                toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t(response.data), life: 3000 });
            }
        });
    };

    const ImagePriview = (id) => {
        HTTPService.POST(`/PrintJob/Preview?printJobId=${id}&type=${"image"}`, '')
            .then((response) => {
                if (response.status === 200) {
                    const tmp = response.data;
                    setImageSrc(tmp);
                    setIsModalImage(true);
                }
                else {
                    toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t(response.data), life: 3000 });
                }
            })
            .catch((error) => {
                console.error('There was an error fetching the image!', error);
            });
    };

    const PrintData = (id: number) => {
        setReprintLoading(prev => ({ ...prev, [id]: true }));
        HTTPService.POST(`/PrintJob/Reprint?printJobId=${id}`, "").then((response) => {
            setReprintLoading(prev => ({ ...prev, [id]: false }));
            if (response.status === 200) {
                toast.current?.show({ severity: 'success', summary: t('successful'), detail: t(response.data), life: 3000 });
                window.location.reload();
            } else if (response.status === 400) {
                toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t(response.data), life: 3000 });
            }
            else {
                toast.current?.show({ severity: 'error', summary: t('mistake'), detail: t('error450'), life: 3000 });
            }
        }).catch((response) => {
            setReprintLoading(prev => ({ ...prev, [id]: false }));
            console.error(response);
        })
    };

    const handleImage = () => {
        setIsModalImage(false);
        setImageSrc('');
    };


    return (
        <>
            <Toast ref={toast} />
            <MUIDatagrid ref={dataGridRef} data={printList?.data} total={printList?.count} columns={tagDataColumns} filterMode="server" onChange={TagFilter} />

            <Modal
                title={<span style={{ fontWeight: 'bold' }}>{t('image_preview')}</span>}
                visible={isModalImage}
                onCancel={handleImage}
                footer={null}
                style={{ maxWidth: '90%', maxHeight: '90%' }} // Modal boyutlarını sınırla
            >
                <div style={{ overflow: 'auto', maxHeight: 'calc(100vh - 130px)' }}>
                    {paginatedImages().length > 0 && (
                        <Image
                            src={`data:image/png;base64,${paginatedImages()[0].imageBase64}`}
                            style={{ width: '100%', height: 'auto' }}
                            alt='Preview'
                        />
                    )}
                    {totalPages > 1 && (
                        <Pagination
                            current={currentPage}
                            pageSize={imagesPerPage}
                            total={imageSrc?.labels?.length}
                            onChange={page => setCurrentPage(page)}
                            style={{ textAlign: 'center', marginTop: '16px' }}
                            itemRender={(page, type, originalElement) => {
                                if (type === 'page') {
                                    return (
                                        <span
                                            style={{
                                                padding: '0 8px',
                                                cursor: 'pointer',
                                                fontWeight: currentPage === page ? 'bold' : 'normal',
                                                display: 'inline-block',
                                                width: '20px',
                                                textAlign: 'center',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {page}
                                        </span>
                                    );
                                }
                                return originalElement;
                            }}
                        />

                    )}
                </div>
            </Modal>
            <Modal
                title={<span style={{ color: 'red' }}>{t('details')}</span>}
                visible={isModalVisible}
                bodyStyle={{ width: 510, height: 350, overflowY: 'auto' }}
                footer={null}
                onCancel={handleCancel}
            >
                <div>
                    {modalData ? modalData.split(',').map((item, index) => (
                        <p key={index} style={{ margin: 0 }}>
                            {item.trim()}
                        </p>
                    )) : (
                        <p>{t('noDetails')}</p>
                    )}
                </div>
            </Modal>
        </>
    );
}

export default PrintsJobsAPI;
